import type { BackToSchool2026SaleVariant } from '~/features/promotions/constants/back-to-school-2026-sale';

import type { PromoCampaignSurfaceRenderers, RegisteredPromoCampaign } from '../types';

import { backToSchool2026CampaignCore } from './campaign-core';
import { backToSchool2026CampaignSurfaces } from './surfaces';

export { BACK_TO_SCHOOL_2026_CAMPAIGN_ID, backToSchool2026CampaignCore } from './campaign-core';

const backToSchool2026PromoCampaignTyped = {
  ...backToSchool2026CampaignCore,
  surfaces: backToSchool2026CampaignSurfaces,
} satisfies PromoCampaignSurfaceRenderers<BackToSchool2026SaleVariant>;

export const backToSchool2026PromoCampaign = backToSchool2026PromoCampaignTyped as RegisteredPromoCampaign;
